import React from 'react'
import { Label } from '@/components/ui/label'
import { cn } from '@/lib/utils'
import { InputFieldProps } from '@/types/field'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { Info } from 'lucide-react'
import { ICON_SIZE_3 } from '@/utils/constant'
import styles from './InputField.module.css'

const InputField: React.FC<InputFieldProps> = ({
    register,
    label,
    error,
    className,
    isRequired,
    hasInfo,
    infoMessage,
    showHelpText,
    helpText,
    hasPassword,
    ...props
}) => {
    return (
        <div className={`${className ? className : ''}`}>
            {label !== '' &&
                <Label htmlFor={props.name} className="text-sm font-medium mb-1 flex items-center gap-1">
                    {label}
                    {hasInfo &&
                        <TooltipProvider>
                            <Tooltip>
                                <TooltipTrigger asChild>
                                    <Info size={ICON_SIZE_3} />
                                </TooltipTrigger>
                                <TooltipContent className='w-90'>
                                    <p>{infoMessage}</p>
                                </TooltipContent>
                            </Tooltip>
                        </TooltipProvider>}
                    {isRequired && <span className="text-red-600 font-medium"> *</span>}
                </Label>
            }
            <input
                {...register}
                {...props}
                onKeyDown={
                    props.onKeyDown ??
                    ((e) => {
                        if (e.key === ' ' && e.currentTarget.value.length === 0) {
                            e.preventDefault()
                        }
                    })
                }
                className={cn(`border-input file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-70 md:text-sm ${hasPassword && 'pr-10'}`, className === 'no-spinner' && styles['no-spinner']
                )}
            />

            {showHelpText && <p className=" mt-1 text-gray-500 text-sm">{helpText}</p>}

            {error && (
                <p className="mt-1 text-sm text-red-600 font-medium">
                    {error}
                </p>
            )}
        </div>
    )
}

export default InputField
